export default __webpack_public_path__ + "static/media/kasambahay-bg.5359c481.webp";